import { DrawerOpenRequest } from 'src/cash-office-display/interfaces/DrawerOpen';
import { checkAndGetArray } from 'src/common/helpers/array-helper';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { store } from 'src/common/redux/configure-store';
import { printReceipts } from 'src/devices/printer-operations';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { getTouchPointNotifications } from 'src/touchpoint-notifications/get-touchpoint-notifications';
import { postDrawerOpen } from './services/post-drawer-open';

export const processBlindPickup = async () => {
  const drawerOpenRequest: DrawerOpenRequest = {
    operatorName: store.getState().user.userName ?? '',
    workerID: store.getState().user.workerId ?? '',
    reasonCode: 'BlindPickup',
  };
  await postDrawerOpen(drawerOpenRequest)
    .then(async (receipt: IReceipt[]) => {
      if (receipt && receipt.length > 0) {
        await printReceipts(checkAndGetArray(receipt)).catch(popupMessage);
      }
      await getTouchPointNotifications();
    })
    .catch(err => {
      popupMessage(err);
    });
};
